import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import ModularSteps from '../steps/modular-steps';
import { SectionContainer } from './styles';
import type { StepsForm } from './types';

interface StepsElementProps {
  form: StepsForm;
  isScheduledVersion: boolean;
}

const StepsElement = ({ form, isScheduledVersion }: StepsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ModularSteps isScheduledVersion={isScheduledVersion} />
    </FormProvider>
  </SectionContainer>
);

export default memo(StepsElement);
